export const MENU_ITEMS = [{
    label: "admin.menu.organisations",
    path: "/organisations",
    iconName: "sitemap",
},
{
    label: "admin.menu.translations",
    path: "/translations",
    iconName: "globe",
},
{
    label: "admin.menu.templates",
    path: "/templates",
    iconName: "pen",
}
];